// GeneralInfo.js
import React, { useState, useContext} from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { UserContext } from "../../context/FormDataContext";
import { Form } from 'react-bootstrap';
import { Controller} from "react-hook-form";
import axios from "axios";
const GeneralInfomation = () => {
  const { userData } = useContext(UserContext);

  const { values, setFieldValue, errors } = useFormikContext();
  const [suggestions, setSuggestions] = useState([]);
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [loading, setLoading] = useState(false);
  

  console.log("errorserrorserrors", errors)

  
  const handleAutocomplete = async (event) => {
    const query = event.target.value;
    if (query.length > 2) {
      try {
        const response = await axios.get(`YOUR_API_ENDPOINT?q=${query}`);
        setSuggestions(response.data);
      } catch (error) {
        console.error('Error fetching autocomplete suggestions:', error);
      }
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = async (event) => {
    const selectedAddress = event.target.value;
    try {
      const response = await axios.get(`YOUR_API_ENDPOINT_FOR_DETAILS?address=${selectedAddress}`);
      const addressDetails = response.data;

      const city = addressDetails.city || addressDetails.sublocality;
      const state = addressDetails.state;
      const zipCode = addressDetails.zipCode;

      setCity(city);
      setState(state);
      setZipCode(zipCode);
    } catch (error) {
      console.error('Error fetching address details:', error);
    }
  };

 
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFieldValue(name, value);
  };
  
console.log(userData.phone, 'this is phone number')
  return (
    <div className="">
      <div className="row">
        <div className="col-12 col-xs-12 col-md-12 px-0">
          <div className="host_form py-0">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="firstName" className="form-label">
                    First name<span class="required">*</span>
                  </label>
                  <Field
                  required
                    type="text"
                    value={values.first_name || userData.firstName}
                    onChange={handleInputChange}
                    className="form-control"
                    
                    id="first_name"
                    name="first_name"
                    // placeholder="John"
                    placeholder="Enter first name"
                    
                  />
                  <ErrorMessage
                    name="first_name"
                    component="div"
                    className="invalid-feedback"
                    
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="lastName" className="form-label">
                    Last name<span class="required">*</span>
                  </label>
                  <Field
                   value={values.last_name || userData.lastName}
                   onChange={handleInputChange}
                    type="text"
                    required
                    className="form-control"
                    id="last_name"
                    name="last_name"
                    placeholder="Enter last name"
                  />
                  <ErrorMessage
                    name="last_name"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="phone_number">
                    Phone number<span className="required">*</span>
                  </Form.Label>
                  <Controller
                    name="phone"
                    disabled={loading}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) => (value && value.length >= 12) || "Phone number must be valid",
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        disabled={loading}
                        {...field}
                        id="phone_number"
                        limitMaxLength={true}
                        defaultCountry="US"
                        placeholder="(000) 000-000"
                        onChange={(value) => handleInputChange(value)} // Ensure React Hook Form value updates
                        value={field.value || userData.phone}
                      />
                    )}
                  />
                  {errors.phone && (
                    <Form.Control.Feedback type="invalid" className="d-block">
                      {errors.phone.message}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email address<span class="required">*</span>
                  </label>
                  <Field
                value={values.email_address || userData.email}
                onChange={handleInputChange}
                required
                    type="email"
                    className="form-control"
                  
                    id="email_address"
                    name="email_address"
                    placeholder="Enter your email"
                  />
                  <ErrorMessage
                    name="email_address"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label htmlFor="addressLine1" className="form-label">
                    Address Line 1<span className="required">*</span>
                  </label>
                  <Field
                    required
                    value={values.addressLine1 || userData.addressLine1}
                    onChange={handleInputChange}
                    onInput={handleAutocomplete}
                    onBlur={handleSelect}
                    type="text"
                    className="form-control"
                    id="addressLine1"
                    name="addressLine1"
                    placeholder="Enter address"
                    list="addressSuggestions"
                  />
                  <datalist id="addressSuggestions">
                    {suggestions.map((suggestion, index) => (
                      <option key={index} value={suggestion} />
                    ))}
                  </datalist>
                  <ErrorMessage
                    name="addressLine1"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label htmlFor="addressLine2" className="form-label">
                  Address Line 2
                  </label>
                  <Field
                    required
                  value={values.addressLine2 || userData.addressLine2}
                  onChange={handleInputChange}
                    type="text"
                    className="form-control"
                    id="addressLine2"
                    name="addressLine2"
                    placeholder="Enter address ext"
                  />
                  <ErrorMessage
                    name="addressLine2"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="state" className="form-label">
                    City<span class="required">*</span>
                  </label>
                  <input type="text"  onChange={handleInputChange} className="selectpicker" id="city" name="city" value={values.city || userData.city} data-live-search="true"/>
                  <ErrorMessage
                    name="city"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>
              <div className="col-md-6 select_2">
                <div className="mb-3">
                  <label htmlFor="fleetSize" className="form-label">
                    State<span class="required">*</span>
                  </label>
                  <select
                   value={values.state || userData.state}
                   onChange={handleInputChange}
                   required
                    as="select"
                    className="selectpicker"
                    id="state"
                    name="state"
                  >
                   <option value="">Select</option>
                    <option value='Alabama'>Alabama</option>
                    <option value='Alaska'>Alaska</option>
                    <option value='Arizona'>Arizona</option>
                    <option value='Arkansas'>Arkansas</option>
                    <option value='California'>California</option>
                    <option value='Colorado'>Colorado</option>
                    <option value='Connecticut'>Connecticut</option>
                    <option value='Delaware'>Delaware</option>
                    <option value='Florida'>Florida</option>
                    <option value='Georgia'>Georgia</option>
                    <option value='Hawaii'>Hawaii</option>
                    <option value='Idaho'>Idaho</option>
                    <option value='Illinois'>Illinois</option>
                    <option value='Indiana'>Indiana</option>
                    <option value='Iowa'>Iowa</option>
                    <option value='Kansas'>Kansas</option>
                    <option value='Kentucky'>Kentucky</option>
                    <option value='Louisiana'>Louisiana</option>
                    <option value='Maine'>Maine</option>
                    <option value='Maryland'>Maryland</option>
                    <option value='Massachusetts'>Massachusetts</option>
                    <option value='Michigan'>Michigan</option>
                    <option value='Minnesota'>Minnesota</option>
                    <option value='Mississippi'>Mississippi</option>
                    <option value='Missouri'>Missouri</option>
                    <option value='Montana'>Montana</option>
                    <option value='Nebraska'>Nebraska</option>
                    <option value='Nevada'>Nevada</option>
                    <option value='New Hampshire'>New Hampshire</option>
                    <option value='New Jersey'>New Jersey</option>
                    <option value='New Mexico'>New Mexico</option>
                    <option value='New York'>New York</option>
                    <option value='North Carolina'>North Carolina</option>
                    <option value='North Dakota'>North Dakota</option>
                    <option value='Ohio'>Ohio</option>
                    <option value='Oklahoma'>Oklahoma</option>
                    <option value='Oregon'>Oregon</option>
                    <option value='Pennsylvania'>Pennsylvania</option>
                    <option value='Rhode Island'>Rhode Island</option>
                    <option value='South Carolina'>South Carolina</option>
                    <option value='South Dakota'>South Dakota</option>
                    <option value='Tennessee'>Tennessee</option>
                    <option value='Texas'>Texas</option>
                    <option value='Utah'>Utah</option>
                    <option value='Vermont'>Vermont</option>
                    <option value='Virginia'>Virginia</option>
                    <option value='Washington'>Washington</option>
                    <option value='West Virginia'>West Virginia</option>
                    <option value='Wisconsin'>Wisconsin</option>
                    <option value='Wyoming'>Wyoming</option>
                  </select>
                  <ErrorMessage
                    name="state"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="zipCode" className="form-label">
                  Zip Code<span class="required">*</span>
                  </label>
                  <Field
                    required
                    value={values.zipCode || userData.zipCode}
                  onChange={handleInputChange}
                    type="text"
                    className="form-control"
                    id="zipCode"
                    name="zipCode"
                    placeholder="zip code"
                  />
                  <ErrorMessage
                    name="zipCode"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralInfomation;
